import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_E6YUN_BASE_WEB = "" } = e6ModuleBaseDataApi;

// 获取电子围栏表格数据
export function fetchFenceTableList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/findByPage`,
    method: "post",
    data
  });
}

// 根据Id查询电子围栏详情
export function fetchFenceDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getCustomAreaByAreaId`,
    method: "get",
    params
  });
}

// 保存新增数据
export function saveFenceAddData(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/savePoint`,
    method: "post",
    data
  });
}
// 保存修改数据
export function saveFenceUpdateData(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/update`,
    method: "post",
    data
  });
}

// 删除电子围栏信息
export function batchFence(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/batch`,
    method: "post",
    data
  });
}

// 导出电子围栏信息
export function exportArea(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/exportArea`,
    method: "post",
    data
  });
}

// 根据key值查字典下拉
export function fetchByDicTypeKey(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/findByDicTypeKey`,
    method: "get",
    params
  });
}

// 添加操作自编号唯一性校验
export function validateFenceName(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/findByAreaNameAndCorpIdAndValid`,
    method: "get",
    params
  });
}

// 添加操作区域名称唯一性校验
export function validateFenceCode(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/findByAreaCodeAndCorpIdAndValid`,
    method: "get",
    params
  });
}

// TODO: 胡智博使用了秦倩雯的api,有可能删除掉
// 查询组织机构
export function fetchOrganizationList() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}

// 电子围栏历史记录
export function fetchfenceUpdateRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronicHistory/findByPageCondition`,
    method: "post",
    data
  });
}

//收/发货类型下拉接口
export function fetchReceiveSendTypeList() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getReceiveSendType`,
    method: "get"
  });
}

// 经纬度获取省市区
export function getCityByLonLat(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getCityByLonLat`,
    method: "get",
    params
  });
}
